import { toZonedTime } from 'date-fns-tz';
import { format } from 'date-fns';

export const formatDateWithTimezone = (
  timeStamp?: string,
  activeTimeZone?: string,
  formatStr: string = 'MMM d, yyyy - h:mm aaa',
) => {
  if (!timeStamp) return '';
  const date = toZonedTime(timeStamp, activeTimeZone || '');
  if (!date) return '';
  return format(date, formatStr);
};
